import React, { useEffect, useState } from "react";
import api from "../../lib/api";

export default function AdminEnquiries() {
  const [enquiries, setEnquiries] = useState([]);

  const load = () => api.get("/admin/enquiries").then(({ data }) => setEnquiries(data));
  useEffect(() => { load(); }, []);

  const markRead = async (e) => {
    if (e.status === "read") return;
    await api.patch(`/admin/enquiries/${e.id}`, { status: "read" });
    setEnquiries((prev) => prev.map((x) => (x.id === e.id ? { ...x, status: "read" } : x)));
  };

  return (
    <div>
      <h1 className="font-serif text-3xl font-bold text-sapore-purple mb-6">Enquiries</h1>
      <div className="grid md:grid-cols-2 gap-4">
        {enquiries.map((e) => (
          <div key={e.id} data-testid={`enquiry-${e.id}`} onClick={() => markRead(e)} className={`bg-white rounded-2xl border p-5 cursor-pointer ${e.status === "new" ? "border-sapore-gold" : "border-sapore-border"}`}>
            <div className="flex items-center justify-between">
              <h3 className="font-serif text-lg text-sapore-purple">{e.name}</h3>
              <span className={`text-xs px-2 py-0.5 rounded-full ${e.status === "new" ? "bg-sapore-gold text-sapore-ink" : "bg-sapore-cream text-sapore-muted"}`}>{e.status}</span>
            </div>
            <p className="text-sm text-sapore-inkSoft mt-1">{e.event_type} · {e.guests || "?"} guests · {e.event_date || "date TBC"}</p>
            <p className="text-sm text-sapore-muted mt-1">{e.phone} · {e.email}</p>
            {e.message && <p className="text-sm text-sapore-inkSoft mt-2 border-t border-sapore-border pt-2">{e.message}</p>}
          </div>
        ))}
        {enquiries.length === 0 && <p className="text-sapore-muted">No enquiries yet.</p>}
      </div>
    </div>
  );
}
